// frontend/klaes-app/src/components/FilmFavs/components/FilmEntry.jsx
import { useState } from 'react';
import { FiEdit2, FiTrash2, FiStar } from 'react-icons/fi';
import { BatteryIndicator } from './BatteryIndicator';
import { Chip } from './Chip';
import { RatingPopup } from './RatingPopup';
import { styles } from '../styles';

export const FilmEntry = ({ entry, currentUser, users, onEdit, onDelete, onUserRating, onShowRatings }) => {
  const [showRatingPopup, setShowRatingPopup] = useState(false);
  const userRating = entry.user_ratings?.[currentUser];
  const hasUserRating = userRating !== undefined;

  return (
    <div className={styles.cardFilmEntry}>
      <div className={styles.cardEntryHeader}>
        <div className={styles.cardEntryType}>{entry.type === 'film' ? '🎬 Film' : '📺 Serie'}</div>
        <div className={styles.cardEntryActions}>
          <button onClick={() => onEdit(entry)}><FiEdit2 /></button>
          <button onClick={() => onDelete(entry.id)}><FiTrash2 /></button>
        </div>
      </div>

      <h3 className={styles.cardEntryName}>{entry.name}</h3>
      <p className={styles.cardEntryDescription}>{entry.description}</p>

      <div className={styles.cardChipContainer}>
        {entry.tags?.map((tag, i) => (
          <Chip key={i} label={tag.name} category={tag.category} />
        ))}
      </div>

      <div className={styles.compRatingSection}>
        <div className={styles.compAverageRating}>
          <span className={styles.compRatingLabel}>Ø Bewertung</span>
          <BatteryIndicator rating={entry.current_ranking} onClick={onShowRatings} />
        </div>

        <div className={styles.compUserRating}>
          <span className={styles.compRatingLabel}>Deine Bewertung</span>
          {hasUserRating ? (
            <BatteryIndicator 
              rating={userRating} 
              isUserRating 
              onClick={() => setShowRatingPopup(true)}
            />
          ) : (
            <button 
              className={`${styles.compRateButton} ${styles.compPulsate}`}
              onClick={() => setShowRatingPopup(true)}
            >
              <FiStar /> Bewerten
            </button>
          )}
        </div>
      </div>

      {showRatingPopup && (
        <RatingPopup 
          onRate={(rating) => onUserRating(entry.id, rating, setShowRatingPopup)}
          onClose={() => setShowRatingPopup(false)}
          currentRating={userRating}
        />
      )}
    </div>
  );
};